module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dispFriendLists),
      expression: "dispFriendLists"
    }],
    staticClass: "list-friend-box clearfix",
    attrs: {
      "id": "vote-friend-list"
    }
  }, [_vm._l((_vm.filterFriendList(_vm.pageCurrent)), function(friendList, indexRow) {
    return _c('div', {
      staticClass: "list-friend-card clearfix",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#votefriend-popup"
      },
      on: {
        "click": function($event) {
          _vm.togglePopup(friendList)
        }
      }
    }, [_c('div', {
      staticClass: "img-box"
    }, [(friendList.namimage) ? _c('img', {
      staticClass: "emp-img",
      attrs: {
        "src": friendList.namimage
      }
    }) : _vm._e(), _vm._v(" "), (!friendList.namimage) ? _c('img', {
      staticClass: "emp-img",
      attrs: {
        "src": require("../../assets/img/no_image.png")
      }
    }) : _vm._e(), _vm._v(" "), (friendList.dtevote === '') ? _c('div', {
      staticClass: "hover-vote"
    }, [_vm._v(_vm._s(_vm.labels['VOTEFRIEND'][36]))]) : _vm._e(), _vm._v(" "), (friendList.dtevote !== '') ? _c('div', {
      staticClass: "edit-vote"
    }, [_c('i', {
      staticClass: "glyphicon glyphicon-ok-sign"
    }), _c('div', [_vm._v(_vm._s(_vm.labels['VOTEFRIEND'][37]))])]) : _vm._e()]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (friendList.dtevote),
        expression: "friendList.dtevote"
      }],
      staticClass: "img-active"
    }), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(friendList.namempt))]), _vm._v(" "), _c('div', {
      staticClass: "position"
    }, [_vm._v(_vm._s(friendList.desc_codpos))]), _vm._v(" "), _c('div', {
      staticClass: "underline"
    }), _vm._v(" "), _c('div', {
      staticClass: "star"
    }, [_c('div', {
      staticClass: "rate"
    }, _vm._l((_vm.stars), function(rate, index) {
      return _c('i', {
        staticClass: "fa fa-star",
        class: _vm.setStar(index, friendList.score)
      })
    }))])])
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 page-box clearfix"
  }, [_c('div', {
    staticClass: "col-xs-2 direction",
    attrs: {
      "disabled": _vm.pageCurrent === 1
    },
    on: {
      "click": function($event) {
        _vm.setCurrentPage(_vm.pageCurrent - 1)
      }
    }
  }, [_c('span', [_vm._v("<")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pcDisp),
      expression: "pcDisp"
    }]
  }, [_vm._v(_vm._s(_vm.labels['VOTEFRIEND'][8]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8 pages"
  }, [_c('span', {
    staticClass: "page-label"
  }, [_vm._v(_vm._s(_vm.labels['VOTEFRIEND'][10]))]), _vm._v(" "), _vm._l((_vm.pageLists), function(indexPage) {
    return _c('span', {
      class: 'page ' + (indexPage === _vm.pageCurrent ? 'active' : ''),
      on: {
        "click": function($event) {
          _vm.setCurrentPage(indexPage)
        }
      }
    }, [_vm._v(_vm._s(indexPage))])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2 direction right",
    attrs: {
      "disabled": _vm.pageCurrent === _vm.maxPage
    },
    on: {
      "click": function($event) {
        _vm.setCurrentPage(_vm.pageCurrent + 1)
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pcDisp),
      expression: "pcDisp"
    }]
  }, [_vm._v(_vm._s(_vm.labels['VOTEFRIEND'][9]))]), _vm._v(" "), _c('span', [_vm._v(">")])])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-551f3a26!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/votefriend/voteFriendList.vue
// module id = 3767
// module chunks = 1